import {Application} from "../Application";
import {Anchor} from "../core/Anchor";
import {IPoint} from "../core/Geom";
import {Environment} from "../data/Environment";
import {Button} from "./Button";

export class ButtonMute extends Button {

    constructor() {
        super("button-mute-off", undefined, Anchor.middleCenter);

        this.toggle = true;
        this.selected = Application.instance.audio.masterVolume === 0;
        this.onChange.add(() => {
            Application.instance.audio.masterVolume = this.selected ? 0 : 1;
        });
        if (Environment.isLive()) {
            this.visible = false;
        }
    }

    public setPosition(size: IPoint) {
        this.x = size.x / 2 - this.width * 0.6;
        this.y = -size.y / 2 + this.height * 0.6;
    }
}
